import spacetime from 'spacetime'

import { CompanyData } from 'modules/accountActivity/domain'

export interface DateRange {
  startTime: number
  endTime: number
}

export const getStartEndTimeFromRange = (range: string): DateRange => {
  const now = spacetime.now()
  switch (range) {
    case 'month':
      return {
        startTime: now.startOf('month').epoch,
        endTime: now.endOf('month').epoch
      }
    case 'week':
      return { startTime: now.startOf('week').epoch, endTime: now.endOf('week').epoch }
    default:
      return { startTime: now.startOf('day').epoch, endTime: now.endOf('day').epoch }
  }
}

export const getAccountDisplayName = (companyData: CompanyData) =>
  companyData.name ?? companyData.domain ?? 'Unnamed account'
